import { EntityService } from '@/services/EntityService';
import { ErrorWrapper, ResponseWrapper } from '@/services/util';

export class BuildingsService extends EntityService {
  static get entity() {
    return 'buildings';
  }

  static async getPossessionForm(params = {}) {
    try {
      const response = await this.request().get(
        `${this.entity}/possession-forms`,
        { params }
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
}
